export const Avatars = {
  _01: require('./01.jpeg'),
  _02: require('./02.jpeg'),
  _Dummy: require('./user_placeholder.png'),
}
